export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categoriesData: Category[] = [
  {
    slug: "training",
    name: "体育培训",
    icon: "ri-user-star-line",
    description: "汇聚500多名专业教练，涵盖30多种运动项目，为不同年龄段学员提供个性化培训方案。",
  },
  {
    slug: "events",
    name: "赛事组织",
    icon: "ri-trophy-line",
    description: "专业赛事策划执行，每年超200场赛事。从企业团建到大型公开赛，全流程服务保障。",
  },
  {
    slug: "fitness",
    name: "运动健身",
    icon: "ri-heart-pulse-line",
    description: "科学健身课程体系，瑜伽、力量训练、HIIT等多样化课程，专属健身计划定制。",
  },
  {
    slug: "venues",
    name: "场馆预约",
    icon: "ri-building-line",
    description: "全国200多家优质场馆在线预约，类型丰富价格透明，随时随地便捷预订。",
  },
  {
    slug: "youth",
    name: "青少年训练",
    icon: "ri-parent-line",
    description: "6-18岁青少年科学运动成长体系，体能开发、技能培养、心理辅导三位一体。",
  },
  {
    slug: "membership",
    name: "会员服务",
    icon: "ri-vip-crown-line",
    description: "多重专属权益：课程折扣、优先预约、专属教练、免费体测、生日礼遇。",
  },
];

export const categoryArticlesMap: Record<string, {
  id: number;
  title: string;
  summary: string;
  date: string;
  author: string;
  image: string;
  tags: string[];
}[]> = {
  training: [
    {
      id: 101, title: "篮球基础训练：从零开始的完整指南",
      summary: "系统讲解篮球基本功训练方法，包括运球、传球、投篮和防守脚步动作，帮助零基础学员快速入门。本指南由云开体育资深篮球教练团队编写，涵盖12个核心训练模块和60个实战练习方法。",
      date: "2026-08-10", author: "张教练",
      image: "https://readdy.ai/api/search-image?query=Basketball%20training%20fundamentals%20on%20indoor%20court%2C%20coach%20demonstrating%20dribbling%20technique%20to%20young%20players%2C%20bright%20clean%20gymnasium%20with%20wooden%20floor%2C%20educational%20sports%20photography&width=800&height=500&seq=art-basketball-101&orientation=landscape",
      tags: ["篮球", "基础训练", "体育培训"],
    },
    {
      id: 102, title: "游泳技巧进阶：自由泳提速的五大秘诀",
      summary: "针对已有游泳基础的学员，详细讲解自由泳提速技巧。从呼吸节奏调整、划水效率优化到转身技术精进，配合水下摄影分析，全面提升游泳速度与耐力。",
      date: "2026-08-05", author: "李教练",
      image: "https://readdy.ai/api/search-image?query=Professional%20swimmer%20demonstrating%20freestyle%20technique%20in%20pool%2C%20crystal%20clear%20water%20with%20underwater%20view%2C%20clean%20modern%20indoor%20pool%20environment&width=800&height=500&seq=art-swimming-102&orientation=landscape",
      tags: ["游泳", "技巧提升", "体育培训"],
    },
    {
      id: 103, title: "羽毛球双打战术：配合与跑位全面解析",
      summary: "深度剖析羽毛球双打比赛中的战术配合与跑位策略。从前场封网到后场进攻，从防守轮转到快速反击，帮助搭档建立默契配合，提升双打竞技水平。",
      date: "2026-07-28", author: "王教练",
      image: "https://readdy.ai/api/search-image?query=Badminton%20doubles%20match%20action%20in%20modern%20indoor%20court%2C%20two%20players%20in%20coordinated%20movement%2C%20dynamic%20sports%20photography%20with%20sharp%20focus%20on%20athletes&width=800&height=500&seq=art-badminton-103&orientation=landscape",
      tags: ["羽毛球", "双打战术", "体育培训"],
    },
  ],
  events: [
    {
      id: 201, title: "2026年度云开体育赛事日历发布",
      summary: "云开体育正式发布2026年下半年赛事日历，涵盖篮球、足球、羽毛球、游泳、马拉松等12个品类，共计超过50场赛事活动。从城市联赛到全国公开赛，精彩赛事贯穿全年。",
      date: "2026-08-08", author: "赛事运营部",
      image: "https://readdy.ai/api/search-image?query=Professional%20sports%20event%20calendar%20display%20in%20modern%20office%2C%20multiple%20sports%20trophies%20and%20medals%2C%20clean%20corporate%20style%20with%20warm%20lighting&width=800&height=500&seq=art-calendar-201&orientation=landscape",
      tags: ["赛事日历", "体育赛事", "赛事组织"],
    },
    {
      id: 202, title: "企业运动会策划指南：从零到一打造精彩赛事",
      summary: "为企业HR和行政人员提供的运动会策划全攻略。从赛事类型选择、场地安排、赛程编排到安全保障，分享云开体育服务500强企业的实战经验，让企业运动会轻松出彩。",
      date: "2026-07-20", author: "赛事策划部",
      image: "https://readdy.ai/api/search-image?query=Corporate%20sports%20day%20event%20in%20large%20stadium%2C%20employees%20participating%20in%20various%20sports%2C%20colorful%20team%20jerseys%2C%20energetic%20atmosphere&width=800&height=500&seq=art-corporate-202&orientation=landscape",
      tags: ["企业运动会", "赛事策划", "赛事组织"],
    },
  ],
  fitness: [
    {
      id: 301, title: "HIIT高强度间歇训练：20分钟高效燃脂方案",
      summary: "介绍HIIT训练的科学原理和实践方法。通过短时间高强度运动与休息交替的训练模式，在20分钟内达到传统有氧1小时的热量消耗效果。附详细动作图解和训练计划表。",
      date: "2026-08-12", author: "刘教练",
      image: "https://readdy.ai/api/search-image?query=High%20intensity%20interval%20training%20in%20modern%20gym%2C%20athletic%20person%20doing%20burpees%2C%20clean%20bright%20fitness%20studio%20with%20mirrors&width=800&height=500&seq=art-hiit-301&orientation=landscape",
      tags: ["HIIT", "燃脂", "运动健身"],
    },
    {
      id: 302, title: "瑜伽入门：零基础也能轻松掌握的10个经典体式",
      summary: "专为瑜伽初学者设计的入门指南。精选10个基础瑜伽体式，包括山式、下犬式、战士式等，每个体式配有详细要领说明和常见错误纠正，让瑜伽练习安全有效。",
      date: "2026-08-01", author: "陈教练",
      image: "https://readdy.ai/api/search-image?query=Calm%20yoga%20practice%20in%20bright%20airy%20studio%2C%20person%20holding%20downward%20dog%20pose%2C%20natural%20light%20through%20windows%2C%20minimal%20serene%20atmosphere&width=800&height=500&seq=art-yoga-302&orientation=landscape",
      tags: ["瑜伽", "入门", "运动健身"],
    },
  ],
  venues: [
    {
      id: 401, title: "如何选择最适合你的运动场馆？五大关键因素",
      summary: "从地理位置、设施设备、环境卫生、价格透明度和用户评价五个维度，详解如何挑选合适的运动场馆。避免花冤枉钱，找到真正适合自己运动需求的优质场馆。",
      date: "2026-08-06", author: "场馆运营部",
      image: "https://readdy.ai/api/search-image?query=Modern%20sports%20facility%20interior%20with%20various%20sports%20areas%2C%20basketball%20court%20and%20fitness%20zone%2C%20bright%20clean%20environment%20with%20natural%20light&width=800&height=500&seq=art-venue-401&orientation=landscape",
      tags: ["场馆选择", "运动场馆", "场馆预约"],
    },
  ],
  youth: [
    {
      id: 501, title: "儿童运动启蒙：为什么6岁是开始运动的最佳年龄",
      summary: "从儿童生理发育和运动科学角度，分析6岁开始系统运动训练的科学依据。分享适合不同年龄段孩子的运动项目推荐，以及家长在培养孩子运动习惯中应扮演的角色。",
      date: "2026-08-03", author: "青训教研组",
      image: "https://readdy.ai/api/search-image?query=Happy%20children%20aged%20six%20to%20eight%20participating%20in%20fun%20sports%20on%20green%20field%2C%20coach%20smiling%2C%20bright%20sunny%20day%20with%20natural%20light&width=800&height=500&seq=art-youth-501&orientation=landscape",
      tags: ["儿童运动", "运动启蒙", "青少年训练"],
    },
    {
      id: 502, title: "青少年体能训练：告别脆皮体质，打造强健体魄",
      summary: "针对当前青少年体质下降的社会现象，介绍科学的青少年体能训练方案。涵盖核心力量、爆发力、协调性和柔韧性四大训练板块，帮助青少年建立强健的身体基础。",
      date: "2026-07-25", author: "体能训练组",
      image: "https://readdy.ai/api/search-image?query=Teenage%20athletes%20training%20with%20resistance%20bands%20in%20bright%20modern%20gym%2C%20focused%20expressions%2C%20professional%20coach%20supervising%2C%20clean%20athletic%20environment&width=800&height=500&seq=art-youth-fitness-502&orientation=landscape",
      tags: ["体能训练", "青少年健康", "青少年训练"],
    },
  ],
  membership: [
    {
      id: 601, title: "云开体育会员权益详解：哪个等级最适合你？",
      summary: "全面对比基础会员、进阶会员和至尊会员的权益差异，帮助您根据自身运动频率和需求选择最合适的会员等级。附会员专享福利清单和常见问题解答。",
      date: "2026-08-09", author: "会员服务部",
      image: "https://readdy.ai/api/search-image?query=Premium%20membership%20cards%20and%20benefits%20on%20clean%20modern%20desk%2C%20elegant%20sports%20lifestyle%20with%20tennis%20racket%2C%20warm%20natural%20lighting&width=800&height=500&seq=art-membership-601&orientation=landscape",
      tags: ["会员权益", "会员等级", "会员服务"],
    },
  ],
};